import React from 'react';
import { Segment, Header, Button, Table, Checkbox} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema nastavnog osoblja u ovoj grupi.</p>;


export default class StudentsWithGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: [],

            showFiltersOnButton: false,
            showFilterMode: null,
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.removeFromGroup = this.removeFromGroup.bind(this);
    }

    onSelectRow(id) {
        const row = this.props.data.find(el => el.id === id);
        const pos = this.state.selectedData.findIndex(el => el.id === row.id);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.id !== row.id);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === this.props.data.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.props.data });
        }
    }

    removeFromGroup() {
        if (!this.state.selectedData.length) {
            toast('Niste odabrali nijednu osobu!');
            return;
        }
        let list = [];
        this.state.selectedData.map(el => {
            list.push(el.id);
        });

        axios.delete('course/groups/remove-staff', { data: list })
            .then(res => {
                toast('Uklanjanje iz grupe je uspješno izvršeno.');
                this.setState({ selectedData: [] });
                this.props.getStaff();
            })
            .catch(err => {
                toast('Došlo je do greške! Uklanjanje iz grupe nije uspješno izvršeno!');
            });
    }

    render() {
        const { selectedData } = this.state;
        return (
            <Segment.Group raised clearing style={{ backgroundColor: 'white' }}>
                <Segment clearing>
                    <Header as="h3">
                  Nastavno osoblje u grupi
                    </Header>
                </Segment>

                <Segment clearing>
                    {this.props.data.length ?
                        <div><Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    { (!this.props.archived && this.props.edit) && <Table.HeaderCell width={1}>
                                        <Checkbox
                                            type="checkbox"
                                            name="checkAllButton"
                                            value={selectedData.length === this.props.data.length}
                                            onChange={this.selectAll}
                                            checked={selectedData.length === this.props.data.length}
                                        />
                                    </Table.HeaderCell>}
                                    <Table.HeaderCell>
                                                Ime
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                                Prezime
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                                Uloga na predmetu
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.props.data.map((el, index) =>
                                (<Table.Row onClick={() => this.onSelectRow(el.id)}>
                                    {(!this.props.archived && this.props.edit) && <Table.Cell verticalAlign="middle">
                                        <Checkbox
                                            name={el.id}
                                            type="checkbox"
                                            checked={selectedData.findIndex(e => e.id === el.id) > -1}
                                        />

                                    </Table.Cell>}
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseImplementationStaff.employee.person.firstName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseImplementationStaff.employee.person.lastName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseImplementationStaff.courseRoleType.name}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                            { (!this.props.archived && this.props.edit) && <Button color="red" floated="right" onClick={this.removeFromGroup}>
                                      Ukloni iz grupe
                        </Button>}
                        </div>
                        : <NoDataMessage />
                    }
                </Segment>
                <ToastContainer hideProgressBar />
            </Segment.Group>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/StaffWithGroup.js